// SHEET 27 — the native, in-app order sheet for the active season, on its own page (it used to sit
// inside Info / Files). Three views: the editable per-vessel sheet, a Procurement rollup that tallies
// every option across the season's boats and lists all the additional requests, and Parts: the parts the
// boats' BOMs need, summed by SAP code (components/OrderSheetParts.tsx). The Warehouse has the same
// rollup on its own page (Warehouse › Order Sheet Rollup, pages/WarehouseRollup.tsx).

import { useState } from 'react';
import { useSeason } from '../season/SeasonContext.js';
import { useAuth } from '../auth/AuthContext.js';
import { OrderSheetGrid } from '../components/OrderSheetGrid.js';
import { OrderSheetProcurement } from '../components/OrderSheetProcurement.js';
import { OrderSheetParts } from '../components/OrderSheetParts.js';
import { PageHeader } from '../components/ui.js';
import { seasonFolderLabel } from '../features/orderList.js';

export function OrderSheet() {
  const { can } = useAuth();
  const { activeSeason } = useSeason();
  const [tab, setTab] = useState<'sheet' | 'procurement' | 'parts'>('sheet');

  return (
    <>
      <PageHeader title={`Order Sheet - ${seasonFolderLabel(activeSeason)}`} />
      <div className="wb-tabs" role="tablist" aria-label="Order sheet view">
        <button type="button" role="tab" aria-selected={tab === 'sheet'} className={`wb-tab ${tab === 'sheet' ? 'on' : ''}`} onClick={() => setTab('sheet')}>Order sheet</button>
        <button type="button" role="tab" aria-selected={tab === 'procurement'} className={`wb-tab ${tab === 'procurement' ? 'on' : ''}`} onClick={() => setTab('procurement')}>Procurement</button>
        <button type="button" role="tab" aria-selected={tab === 'parts'} className={`wb-tab ${tab === 'parts' ? 'on' : ''}`} onClick={() => setTab('parts')}>Parts</button>
      </div>
      {tab === 'sheet' && <OrderSheetGrid season={activeSeason} canWrite={can('production:write')} />}
      {tab === 'procurement' && <OrderSheetProcurement season={activeSeason} />}
      {tab === 'parts' && <OrderSheetParts season={activeSeason} />}
    </>
  );
}
